import { useWhiteLabel } from '@allesauto/core/whiteLabel';
import translate from '@allesauto/i18n';
import { isWhiteLabel } from '@allesauto/utils/funcs.ts';
import { Routes_DE as Routes } from '@allesauto/utils/routes';
import { NextPageContext } from 'next';
import React, { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Footer from '@/components/Footer/Footer';

import HeaderContainer from '@/global/containers/HeaderContainer';
import SeoContainer from '@/global/containers/SeoContainer';
import {
  REDIRECT_FROM,
  setUserWasRedirectedFrom,
} from '@/store/redux/slices/pages/login';

import Login from '../../../components/Account/Login/Login';
import UserAccountLayout from '../../../layouts/UserAccount';

export interface LoginPageProps {
  query: any;
  imagePath: string;
}

const Page: FC<React.PropsWithChildren<LoginPageProps>> = ({ query }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const whiteLabel = useWhiteLabel();

  useEffect(() => {
    let redirectFrom = REDIRECT_FROM.DEFAULT;

    if (query?.redirectTo?.match(Routes.CHECKOUT)) {
      redirectFrom = REDIRECT_FROM.CHECKOUT;
    }

    if (query?.redirectTo?.match(Routes.TRADE_IN)) {
      redirectFrom = REDIRECT_FROM.TRADE_IN;
    }

    dispatch(setUserWasRedirectedFrom(redirectFrom));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UserAccountLayout
      headerContent={<HeaderContainer />}
      footerContent={<Footer />}
    >
      <SeoContainer
        title="Login"
        robots="index,nofollow"
        pageHeadline={false}
      />
      <Login
        title={translate(intl, 'ui.FORMS.LOGIN.TITLE')}
        emailLabel={translate(intl, 'ui.FORMS.LOGIN.EMAIL_PLACEHOLDER')}
        passwordLabel={translate(intl, 'ui.FORMS.LOGIN.PASSWORD_PLACEHOLDER')}
        loginButtonText={translate(intl, 'ui.FORMS.LOGIN.LOGIN_BUTTON_TEXT')}
        forgottenPasswordCtaText={translate(
          intl,
          'ui.FORMS.LOGIN.FORGOTTEN_PASSWORD_CTA_TEXT'
        )}
        merchantPortalCtaText={translate(
          intl,
          'ui.FORMS.LOGIN.MERCHANT_PORTAL_CTA_TEXT'
        )}
        createAccountTitle={
          isWhiteLabel(whiteLabel)
            ? translate(intl, 'ui.FORMS.LOGIN.CREATE_ACCOUNT_TITLE_WL')
            : translate(intl, 'ui.FORMS.LOGIN.CREATE_ACCOUNT_TITLE')
        }
        registerButtonText={translate(
          intl,
          'ui.FORMS.LOGIN.REGISTER_BUTTON_TEXT'
        )}
        secureConnectionText={translate(
          intl,
          'ui.FORMS.USER_ACCOUNT.SECURE_CONNECTION'
        )}
      />
    </UserAccountLayout>
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const { query } = context;

  return {
    props: {
      query,
      imagePath: '',
    },
  };
}

export default Page;
